import React from 'react'
import "./footer.scss"
function Footer() {
  return (
    <footer>
        <div className="footerContainer">
            <a className='footerLogo'><img src={require("../images/logo.png")} alt="" /></a>
            <h3>Kanafani Travel and Tourism</h3>
            <h3>مكتب كنفاني للسياحة و السفر</h3>
            <a className='by' target='_blank' href='https://anwar-dev.com'>This website developed by Anwar Takriti</a>
        </div>
    </footer>
  )
}

export default Footer